var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivacypolicyBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 239,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCF2F4",
    fillRule: "evenodd",
    d: "m0 102 24 10.213c24 10.214 72 30.288 120 50.715 48 20.427 96 40.501 144 38.036 48-2.465 96-27.823 144-33.105 48-4.931 96 10.213 144 5.282 48-5.282 96-30.64 144-27.822 48 2.465 96 32.753 144 32.753s96-30.288 144-48.249c48-17.61 96-22.54 144-25.358 48-2.465 96-2.465 144 5.283 48 7.396 96 22.892 120 30.288l24 7.748V239H0V102Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 48.805,
    fill: "#FFD771",
    transform: "matrix(-1 0 0 1 14.805 148.195)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.873,
    stroke: "#FFD771",
    strokeWidth: 1.795,
    transform: "matrix(-1 0 0 1 32.419 69.77)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1431.22,
    cy: 140.548,
    r: 56.548,
    fill: "#FFD771"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41D2CA",
    d: "m1405.36 153.677-46.02 26.569v-53.137l46.02 26.568Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07878E",
    d: "m1461.51 153.678-65.13 37.601v-75.203l65.13 37.602Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41D2CA",
    d: "m151.283 110.705-39.962 23.072V87.632l39.962 23.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07878E",
    d: "m200.046 110.705-56.557 32.653V78.052l56.557 32.653Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1329.73,
    cy: 165.73,
    r: 13.102,
    stroke: "#FFD771",
    strokeWidth: 1.255
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.73,
    cy: 193.73,
    r: 13.102,
    stroke: "#FFD771",
    strokeWidth: 1.255
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1280.53,
    cy: 135.532,
    r: 7.532,
    fill: "#FFD771"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.532,
    cy: 196.532,
    r: 7.532,
    fill: "#FFD771"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1277,
    cy: 88.001,
    r: 3.374,
    stroke: "#FFD771",
    strokeWidth: 1.255
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1319.69,
    cy: 100.001,
    r: 3.374,
    fill: "#FFD771",
    stroke: "#FFD771",
    strokeWidth: 1.255
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41D2CA",
    d: "m36.22 192.016-15.915 9.188v-18.377l15.915 9.189Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07878E",
    d: "m55.642 192.015-22.524 13.004v-26.007l22.524 13.003Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1429.73,
    cy: 13.73,
    r: 13.102,
    stroke: "#FFD771",
    strokeWidth: 1.255
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v239H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicyBg);
export default __webpack_public_path__ + "static/media/privacypolicy-bg.7c2b9b7f796416118917a38db4f33d40.svg";
export { ForwardRef as ReactComponent };